<template>
    <div class="collapse-box">
        <div class="collapse-title clearfix" @click=' isOpen= !isOpen '>
            <i class="fa fa-fw" :class=' isOpen?"fa-minus-square":"fa-plus-square" '></i>
            {{ data.title }}
        </div>

        <div class="collapse-contents" :class='{closed: !isOpen}'>
            <div style="border-top: 1px dotted #ccc; padding: 8px;">
                <div v-for=' (item, idx) in data.content ' :key='idx'>
                    <text-html v-if=' item.type==="text" ' :data='item' />
                    <code-highlight v-else-if=' item.type==="code" ' :data='item' />
                    <iv v-else-if=' item.type==="img" ' :data='item' />
                    <h2 v-else-if=' item.type==="subtitle" ' v-html='item.content' />
                    <youtube v-else-if=' item.type==="youtube" ' :data='item' />
                    <exlink v-else-if=' item.type==="link" ' :data='item' />
                    <collapse v-else-if=' item.type==="Collapse" ' :data='item' />
                    <tab v-else-if=' item.type==="tab" ' :data='item'
                        :titleGroup=' titleGroup ' @set-group=' setTabGroup '/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Collapse from './Collapse.vue'; // 중첩은...
import TextHtml from './TextHtml.vue';
import CodeHighlight from './CodeHighlight.vue';
import Image from './ImageLink.vue';
import Youtube from './Youtube.vue';
import ExternalLink from './ExternalLink.vue';

export default {
    name: 'collapse',
    components: {
        "text-html": TextHtml,
        "code-highlight": CodeHighlight,
        "iv": Image,
        "youtube": Youtube,
        "exlink": ExternalLink,
        // "collapse": Collapse, // nested... allow?
    },
    props: {
        isAdmin: { type: Boolean },
        data: { type: [Object, undefined] }
    },
    data(){
        return {
            isOpen: false
        }
    },
    created(){        
        this.isOpen = this.data.isOpen;
    }
}
</script>

<style>
.collapse-box {
    border: 1px solid #ccc;
    border-radius: 8px;
    margin: 10px auto;
}
.collapse-title {
    padding: 16px;
    cursor: pointer;
}
.collapse-title .fa-fw {
    font-size: 1.5em;
    float: right;
}
.collapse-contents{
    overflow: hidden;

    max-height: 10000px;
    transition: .5s;
}
.collapse-contents.closed{
    max-height: 0;
    transition: .5s;
}
</style>


